module.exports = __webpack_public_path__ + "static/media/item2.362e9719.jpg";